import React, { FunctionComponent } from "react";
import commonStyles from "../../CommonStyles/CommonGraphStyles.module.css";
import IntBarChartOrg from "../IntBarChartOrg/IntBarChartOrg";
import IntBarTable from "../IntBarTable/IntBarTable";
import { Bar } from "react-chartjs-2";

type props = {
  analyticsData: any;
  usersList: any;
  checked: boolean;
  teamsData: any;
  history: any;
  filter: "MTD" | "YTD" | "PM" | "All" | "CUSTOM";
  source: boolean;
  taskFilter: any;
  leadFilter: any;
};

const InterestedProject: FunctionComponent<props> = ({
  analyticsData,
  usersList,
  checked,
  history,
  teamsData,
  filter,
  source,
  taskFilter,
  leadFilter,
}) => {
  return (
    <>
      <div id="interestedProject" className={commonStyles.graphContainer}>
        <IntBarChartOrg
          analyticsData={analyticsData}
          heading={"Interested Projects"}
          type={"project"}
          color={["#ED563B", "#173F5F"]}
          GraphType={Bar}
          style={{ width: "100%", height: "350px" }}
          history={history}
          filter={filter}
        />
      </div>

      <div id="interestedProject" className={commonStyles.graphContainer}>
        <IntBarTable
          type={"project"}
          data={analyticsData}
          heading={"Interested Projects Summary"}
          usersList={usersList}
          checked={checked}
          teamsData={teamsData}
          style={{ width: "100%" }}
          show={false}
          filter={filter}
          history={history}
          source={source}
          taskFilter={taskFilter}
          leadFilter={leadFilter}
        />
      </div>
    </>
  );
};

export default InterestedProject;
